/* eslint-disable import/prefer-default-export */
export const now = () => new Date();
